export const getPartners = ({ partnerReducer: { partners = [] } = {} }) =>
partners;
export const getPartnerFilter = ({ partnerReducer: { filter = {} } = {} }) =>
  filter;
export const getPartnerCount = ({ partnerReducer: { count = 0 } = {} }) =>
  count;
